import { NullState, SearchBox } from '@mi-front/ui';
import React from 'react';
import { Grid } from '@mui/material';
import { PermissionState } from '../../../types';
import { BasePermission } from '../BasePermission';

export interface Props<T extends PermissionState> {
  readonly permissionsState: readonly T[];
  readonly filterPlaceholder: string;
  readonly emptyListMsg: React.ReactNode;
  readonly canModify: (pState: T) => boolean;
  readonly isVisible: (pState: T) => boolean;
  readonly renderInfo: (pState: T) => React.ReactNode;
  readonly isUpdating: (pState: T) => boolean;
  readonly events: {
    setFilter: (text: string) => void;
    onToggleEnabled: (pState: T, enabled: boolean) => Promise<void>;
  };
}

export function PermissionsViewP<T extends PermissionState>(p: Props<T>) {
  const anyVisible = !!p.permissionsState.find(p.isVisible);

  return (
    <div data-cy="permissions-view">
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12} md={4}>
          <div>
            <SearchBox
              data-cy="permissions-filter"
              onSearch={(value: string) => p.events.setFilter(value)}
              placeholder={p.filterPlaceholder}
              sx={{ mb: 2 }}
            />
          </div>
        </Grid>
      </Grid>
      <div>
        {!anyVisible && <NullState className="p-4">{p.emptyListMsg}</NullState>}
        {p.permissionsState.map((pState, index) => {
          return (
            <div
              key={index}
              style={{
                display: p.isVisible(pState) ? 'block' : 'none',
                marginBottom: '1rem',
              }}
            >
              <BasePermission
                canModify={p.canModify(pState)}
                permissionState={pState}
                disabled={p.isUpdating(pState)}
                onToggleEnabled={(enabled) => {
                  p.events.onToggleEnabled(pState, enabled);
                }}
              >
                {p.renderInfo(pState)}
              </BasePermission>
            </div>
          );
        })}
      </div>
    </div>
  );
}
